<template>
  <section class="send-msg slate-bg">
    <div class="container contain-small">
      <r-grid columns="2" columns-s="1">
        <r-cell span="1" span-s="row">
          <h2>We want to hear from you</h2>
          <p>
            If you are interested in working with us, having your business
            featured, or just want to share some feedback, we'd love to hear
            from you! Send a message or
            <a class="link-white" href="mailto:wheretomeatuk@gmail.com">
              email us.
            </a>
          </p>
        </r-cell>
        <r-cell span="1" span-s="row">
          <form
            class="w-100"
            action="https://formspree.io/xayoejwl"
            method="POST"
          >
            <label
              ><span>Name</span>
              <input required type="text" class="w-100" />
            </label>
            <label
              ><span>Email address</span>
              <input required type="email" class="w-100" name="_replyto" />
            </label>
            <label
              ><span>Your message</span>
              <textarea rows="3" class="w-100" name="message"></textarea>
            </label>
            <button class="btn btn-outline btn-white w-100 mt-16" type="submit">
              Send message
            </button>
          </form>
        </r-cell>
      </r-grid>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import "@/global-styles/variables.scss";

.send-msg {
  color: $white;
}
</style>

<script>
export default {
  name: "SendMessage"
};
</script>
